const getNextUndo = (rootState) => rootState.ws.history.undo[rootState.ws.history.undo.length - 1];

export default getNextUndo;
